import { createAsyncThunk } from '@reduxjs/toolkit';
import { ICountry } from 'modules/ScrShopNew/store/slices/countries/types';

import { Api } from 'old-store/utils';
import ApiErrors from 'old-store/utils/API/APIErrors';
import { setPostalCodeCountries } from 'helpers/postalCode/postalCodeCountries';

export const fetchCountries = createAsyncThunk<ICountry[], void>(
  'countries/fetchCountries',
  async (_, { rejectWithValue }) => {
    try {
      const response = await Api.Countries.get();

      ApiErrors.checkOnApiError(response);

      // The zipcode field validator is a static function with no store access, so it reads the
      // list from here to resolve the selected country's ISO code.
      setPostalCodeCountries(response.result);

      return response.result;
    } catch (e) {
      console.error(e);

      return rejectWithValue('Failed to fetch countries');
    }
  }
);
